import { IClientDetailsValidation, IRegistrationData } from '@/domain/interfaces/IUser';
import { IClientDetail } from '@/domain/interfaces/ICart';

import { usePasswordValidation } from '@/domain/genericValidations/usePasswordValidation';

import validateClientDetailsUseCase from '@/domain/useCases/validateClientDetailsUseCase';
import { translate } from '@/domain/utils/translate';
/**
 * Caso de uso de registro de nuevo cliente - Validaciones
 * @param {IRegistrationData} user - data para nuevo registro
 * @returns {IUserResponse} - usuario registrado
 */
const registerUser = (user: IRegistrationData): IClientDetailsValidation[] => {

  const validaPassword = usePasswordValidation;
  
  const PASSWORD_MESSAGE = translate('session.error_change_password_text');

  /** Objeto de respuesta con todos los errores */
  const errors: IClientDetailsValidation[] = [];

  
  const client:IClientDetail = {shippingType:null, ...user};

  const errorsUseCase: IClientDetailsValidation[] = validateClientDetailsUseCase(client);
  if (errorsUseCase) {
    errorsUseCase && errorsUseCase.length > 0 && errors.splice(0,errors.length,...errorsUseCase);
  }    

  if (!validaPassword(user.password!)) {
    errors.push({
      error: true,
      field: 'PASSWORD',
      message: PASSWORD_MESSAGE,
    });
  }

  if (user.password === user.email) {
    errors.push({
      error: true,
      field: 'PASSWORD',
      message: PASSWORD_MESSAGE,
    });
  }

  return errors;
}

export { registerUser };